<template>
  <div class = "paginaDedicata">
    <NormalHeader :data="header"/>
    <img :src="logo" class = "imagine">
    <h1 class = "title">{{$t(title)}}</h1>
    <p v-html="$t(text1)" class = "text"></p>
    <ul type="disc">
      <li v-html="$t(bullet1)"></li>
      <li v-html="$t(bullet2)"></li>
      <li v-html="$t(bullet3)"></li>
    </ul>  
    <p v-html="$t(text2)" class = "text"></p>
    <ul>
      <li v-html="$t(bullet4)"></li>
      <li v-html="$t(bullet5)"></li>
    </ul>
    <img :src="img1" class = "poza">
    <h2 class = "subtitle">{{$t(subtitle)}}</h2>
    <p v-html="$t(text3)" class = "text"></p>
    <img :src="img2" class = "poza">
    <p v-html="$t(text4)" class = "text"></p>
    <ul>
      <li v-html="$t(bullet6)"></li>
      <li v-html="$t(bullet7)"></li>
      <li v-html="$t(bullet8)"></li>
      <li v-html="$t(bullet9)"></li>
    </ul>
    <p v-html="$t(text5)" class = "text"></p>
    <ul>
      <li v-html="$t(bullet10)"></li>
      <li v-html="$t(bullet11)"></li>
      <li v-html="$t(bullet12)"></li>
    </ul>
  </div> 
</template>

<script>
import NormalHeader from '@/components/global-components/NormalHeader'
export default {
  components:{
    NormalHeader
  },
  data() {
    return {
      header: {
        transparent: false
      },
      logo: "https://i.imgur.com/NgWaMUW.jpg",
      img1: "https://i.imgur.com/qmNQQ9o.jpg",
      img2: "https://i.imgur.com/HfRPBKp.png",
      title: "dedicate.bcr.title",
      subtitle: "dedicate.bcr.subtitle",
      text1: "dedicate.bcr.text1",
      text2: "dedicate.bcr.text2",
      text3: "dedicate.bcr.text3",
      text4: "dedicate.bcr.text4",
      text5: "dedicate.bcr.text5",
      bullet1: "dedicate.bcr.bullet1",
      bullet2: "dedicate.bcr.bullet2",
      bullet3: "dedicate.bcr.bullet3",
      bullet4: "dedicate.bcr.bullet4",
      bullet5: "dedicate.bcr.bullet5",
      bullet6: "dedicate.bcr.bullet6",
      bullet7: "dedicate.bcr.bullet7",
      bullet8: "dedicate.bcr.bullet8",
      bullet9: "dedicate.bcr.bullet9",
      bullet10: "dedicate.bcr.bullet10",
      bullet11: "dedicate.bcr.bullet11",
      bullet12: "dedicate.bcr.bullet12",
      header: {
        transparent: false
      }
    }
  }
} 
</script>

<style scoped lang="scss">
.imagine {
  margin-top: 5%!important;
  margin-bottom: 6%!important;
  padding-top: 0px;
  height: 15vh;
  display: block;
  margin: auto;
}
.poza {
  display: block;
  margin: auto;
  margin-top: 3%!important;
  margin-bottom: 3%!important;
  max-height: 40vh;
}

.title {
  margin-bottom: 3%;
  font-size: 35px!important;
}

.text {
  text-align: center;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
  margin-top: 2%;
  font-size: 20px!important;
}

.subtitle {
   font-size: 30px!important;
}

.paginaDedicata {
  color: $primary-color !important;
  margin-bottom: 30px;
}
ul { 
  display: block;
  list-style-type: disc;
  color: black;
  margin-left: 15%;
  margin-right: 15%;
}
li{
  margin-bottom: 3px!important;
  text-align: center;
  font-size: 20px!important;
  margin-left: 2%;
  margin-right: 2%;
  list-style-position: inside;
}

a{
  text-align: center;
  color: black;
  font-size: 20px!important;
  display: block;
  margin-bottom: 5px;
}

@media screen and (max-width: 600px) {
  .imagine {
    height: 9vh;
  }
  .subtitle {
   margin-top: 7%!important;
  }
  .title {
    margin-top: 7%!important;
  }
}

</style>